/**
 * Opening the command palette from anywhere. The host (mounted once in the
 * frame) listens for this event, so a trigger needs no context or props.
 */

export const OPEN_PALETTE_EVENT = "drtutor:command-palette";

export function openCommandPalette(): void {
  window.dispatchEvent(new CustomEvent(OPEN_PALETTE_EVENT));
}

/** "⌘K" on Apple devices, "Ctrl K" elsewhere. */
export function paletteShortcutLabel(): string {
  const platform =
    (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform ??
    navigator.platform ??
    "";
  return /mac|iphone|ipad/i.test(platform) ? "⌘K" : "Ctrl K";
}
